const DB_NAME = "heveatalent_offline";
const STORE = "fotos";

const openDB = () =>
  new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        const store = db.createObjectStore(STORE, { keyPath: "id" });
        store.createIndex("fila", "fila");
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });

export const salvarFotoOffline = async (fila, dados) => {
  const db = await openDB();
  const item = { id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`, fila, criadoEm: new Date().toISOString(), ...dados };
  await new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).put(item);
    tx.oncomplete = resolve;
    tx.onerror = () => reject(tx.error);
  });
  return item;
};

export const listarFotosOffline = async (fila) => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const req = db.transaction(STORE).objectStore(STORE).index("fila").getAll(fila);
    req.onsuccess = () => resolve((req.result || []).sort((a, b) => (a.criadoEm || "").localeCompare(b.criadoEm || "")));
    req.onerror = () => reject(req.error);
  });
};

export const removerFotoOffline = async (id) => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).delete(id);
    tx.oncomplete = resolve;
    tx.onerror = () => reject(tx.error);
  });
};

export const isNetworkError = (err) => !navigator.onLine || (!err?.response && err?.code !== "ECONNABORTED");
